import { crv, cva } from '@/styled-system/css';

export const dividerRecipe = cva({
  variants: {
    tone: {
      'muted': {
        backgroundColor: 'Divider.muted.bg',
      },
      'muted-alt': {
        backgroundColor: 'border.muted-alt',
      },
      'emphasized': {
        backgroundColor: 'Divider.emphasized.bg',
        marginInline: 'auto',
      },
    },
    ...crv('orientation', {
      horizontal: {
        height: 'pipe.weight.default',
        width: '100%',
      },
      vertical: {
        height: '100%',
        width: 'pipe.weight.default',
      },
    }),
  },
  compoundVariants: [
    {
      orientation: 'horizontal',
      tone: 'emphasized',
      css: {
        width: '3600',
        height: 'pipe.weight.thick',
      },
    },
  ],
});
